export const Badge = ({ children }: { children: React.ReactNode }) => {
  return (
    <span className="ml-2 px-2 py-1 bg-sky-100 text-sky-600 font-semibold text-xs rounded-lg">
      {children}
    </span>
  );
};
